div.left {
	display: flex;
	align-items: center;
	/* flex items will refuse to shrink below their minimum intrinsic width, unless you explicitly specify "min-width" or "width" or "max-width" on them */
	min-width: 0;
	max-width: 100%;
	flex: 0 50 auto;
}

div.headerRowLeft {
	align-items: center;
	display: flex;
	/* reducing half width by 32px to give some right padding to the column and avoid to overlap with the toolbar icon */
	flex: 0 0 calc(50% - 32px);
	max-width: 100%;
}

.title {
	display: flex;
	align-self: stretch;
	flex: 0 1 auto;
	/* flex items will refuse to shrink below their minimum intrinsic width, unless you explicitly specify "min-width" or "width" or "max-width" on them */
	min-width: 0;
	max-width: 100%;
}

.readOnlyPlanLozenge {
	margin-left: var(--jpo-common-base-spacing);
}

div.headerRowBacklogSeparator,
div.headerRowSeparator {
	padding-top: 0;
	padding-bottom: 0;
	border-top: thin solid var(--ds-border-inverse, var(--adg3-color-N0));
	border-bottom: thin solid var(--ds-border, var(--adg3-color-N50));
}

div.headerRowBacklogSeparator {
	height: 0px;
	justify-content: center;

	&:hover {
		border-top: thin solid var(--ds-border-brand, var(--adg3-color-B100));
		border-bottom: thin solid var(--ds-border-brand, var(--adg3-color-B100));
	}
}

.toolBarButtonIcon {
	background: var(--ds-icon-inverse, var(--adg3-color-N0));
	border-radius: 50%;
	height: 24px;
	width: 24px;
	z-index: 11;
	border: 1px solid var(--ds-border, var(--adg3-color-N50));

	&:hover {
		background: var(--ds-icon-brand, var(--adg3-color-B100));
		border: 1px solid var(--ds-border-brand, var(--adg3-color-B100));

		& svg {
			color: var(--ds-text-inverse, var(--adg3-color-N0));
			fill: var(--ds-icon-inverse, var(--adg3-color-N0));
		}
	}

	&:active {
		background: var(--ds-icon-brand, var(--adg3-color-B200));
		border: 1px solid var(--ds-border-brand, var(--adg3-color-B100));

		& svg {
			color: var(--ds-text-inverse, var(--adg3-color-N0));
			fill: var(--ds-icon-inverse, var(--adg3-color-N0));
		}
	}

	& button {
		border-radius: 50%;
		height: 24px;
	}
}

div.toolBar {
	border-bottom: thin solid var(--ds-border, var(--adg3-color-N50));
	padding: var(--jpo-common-base-spacing);
}

.toolBarFiltersSettingsContainer {
	display: flex;
	gap: var(--jpo-common-base-spacing);
}

div.toolBarRight {
	display: flex;
}

div.headerRow {
	padding: var(--jpo-common-base-spacing);
}

.viewSwitcherWrapper {
	margin-left: var(--jpo-common-base-spacing);
}
